import { Injectable } from '@angular/core';
import { StoreBase } from '@stores/abstract';
import { Funnel } from '@stores/models';

@Injectable({ providedIn: 'root' })
export class FunnelStore extends StoreBase<Funnel> {
  override storeName = 'FunnelStore';
}
